import type { IPackageAvailability, IRateAvailability, IRoomAvailability } from "@app/availability/types";
import { BookableType } from "@app/common/types";

import { matchShortId } from "../ids/generateIds";

export const getRateByShortId = (item: IRoomAvailability | IPackageAvailability | null, shortId: string): IRateAvailability | undefined =>
    item?.bookable_type === BookableType.Room
        ? (item?.rates || []).find((r) => matchShortId(shortId, r.id))
        : (item?.rooms[0]?.rates || []).find((r) => matchShortId(shortId, r.id));
